


































































































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import LineChart from '@/components/Shared/LineChart.vue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatNumber, formatHours, formatChangePercent } from '@/lib/reportFormatters';

@Component({ name: 'WorkerReports', components: { LineChart } })
export default class WorkerReports extends GiganautVue {

  get workerLabel(): string { return this.Labels.worker || 'Worker'; }
  get workersLabel(): string { return this.Labels.workers || 'Workers'; }

  cvsParsedHeaders = [
    { text: 'User', value: 'userName' },
    { text: 'CVs Parsed', value: 'count', align: 'end' },
  ];

  dataPointHeaders = [
    { text: 'Type', value: 'label' },
    { text: 'Count', value: 'value', align: 'end' },
  ];

  get utilisationHeaders() {
    return [
      { text: 'Position', value: 'label' },
      { text: this.workersLabel, value: 'workers', align: 'end' },
      { text: 'Hours', value: 'hours', align: 'end' },
      { text: 'Avg Hours', value: 'avgHours', align: 'end' },
    ];
  }

  get cvsParsedByUser() { return ManagementReportsModule.cvsParsedByUser; }
  get workerRegistration() { return ManagementReportsModule.workerRegistration; }
  get workerUtilisation() { return ManagementReportsModule.workerUtilisation; }
  get workerCompliance() { return ManagementReportsModule.workerCompliance; }

  get cvsParsedTrendChart() {
    const trend = this.cvsParsedByUser ? this.cvsParsedByUser.trend : [];
    return {
      labels: trend.map(t => t.period),
      datasets: [{
        label: 'CVs Parsed',
        borderColor: '#4caf50',
        backgroundColor: 'rgba(76,175,80,0.1)',
        data: trend.map(t => t.value),
        fill: true,
      }],
    };
  }

  get registrationTrendChart() {
    const trend = this.workerRegistration ? this.workerRegistration.trend : [];
    return {
      labels: trend.map(t => t.period),
      datasets: [{
        label: 'Registrations',
        borderColor: '#3f51b5',
        backgroundColor: 'rgba(63,81,181,0.1)',
        data: trend.map(t => t.value),
        fill: true,
      }],
    };
  }

  get numberChartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
    };
  }

  fmtNum(v: number) { return formatNumber(v); }
  fmtHours(v: number) { return formatHours(v); }
  fmtChange(v: number) { return formatChangePercent(v); }
}
